import React from "react"
import * as css from "./Accordion.module.css"
import AccordionItem from "./AccordionItem"

function Accordion({ faqs }) {
  return (
    <ul className={css.accordion}>
      {faqs.map((faq, index) => (
        <AccordionItem key={index} faq={faq} />
      ))}
    </ul>
  )
}

export default Accordion
